import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Sparkles } from "lucide-react";

export default function NewIdea() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [idea, setIdea] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/projects", { title, idea });
      toast.success("Fikrin oluşturuldu");
      navigate(`/project/${res.data.id}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-12">
      <button onClick={() => navigate("/dashboard")} data-testid="back-button"
        className="flex items-center gap-2 text-white/50 hover:text-gold transition-colors mb-8 text-sm">
        <ArrowLeft className="w-4 h-4" /> Panele dön
      </button>
      <p className="text-sm uppercase tracking-[0.3em] text-gold mb-3">Yeni Proje</p>
      <h1 className="font-serif text-4xl lg:text-5xl mb-3">Fikrini anlat</h1>
      <p className="text-white/60 mb-10">
        Aklındaki hikâyeyi, atmosferi ve mesajı yaz. Ne kadar detay verirsen AI o kadar iyi bir senaryo üretir.
      </p>

      <form onSubmit={submit} className="space-y-6" data-testid="new-idea-form">
        <div>
          <Label className="text-white/70">Proje Başlığı</Label>
          <Input value={title} onChange={(e) => setTitle(e.target.value)} required
            data-testid="idea-title-input"
            className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold h-11"
            placeholder="Örn: Sahil kasabasında bir veda" />
        </div>
        <div>
          <Label className="text-white/70">Fikir / Senaryo Özeti</Label>
          <Textarea value={idea} onChange={(e) => setIdea(e.target.value)} required rows={8}
            data-testid="idea-text-input"
            className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold resize-none"
            placeholder="Hikâyenin geçtiği yer, karakterler, duygu ve vermek istediğin mesajı anlat…" />
        </div>
        <Button type="submit" disabled={loading} data-testid="create-idea-button"
          className="bg-gold text-black hover:bg-gold-light rounded-md h-12 px-8">
          <Sparkles className="w-4 h-4 mr-2" />
          {loading ? "Oluşturuluyor…" : "Projeyi Oluştur"}
        </Button>
      </form>
    </div>
  );
}
